import assetVersion from "./assetVersion.json";

// Adresy ciężkich zasobów z wersją (hashem zawartości) w query stringu.
// Wersję generuje scripts/assetVersion.js przy każdym buildzie - po
// aktualizacji modelu/HDRI URL się zmienia i przeglądarki pobierają świeży
// plik, a dopóki pliki są niezmienione, mogą być cache'owane długoterminowo.
export const MODEL_URL = `/models/showcase_room.glb?v=${assetVersion.version}`;
export const HDRI_URL = `/models/hdri.hdr?v=${assetVersion.version}`;
